/**
 * More Tests page — English (nested for t('tests.…'), shared by m & pc)
 */
export default {
	meta: {
		breadcrumb: "More Tests",
		title: "More Tests - SeerQ",
		keywords: "online tests,more tests,fortune tests,psychology tests",
		description:
			"Explore more online tests across psychology, love, career, metaphysics and more — find the right test for you.",
	},
	pageHeader: {
		breadcrumbHome: "Home",
		breadcrumbCurrent: "More Tests",
		searchPlaceholder: "Search by test keyword",
		searchButton: "Search",
		clearSearch: "Clear search",
	},
	rankSidebar: {
		title: "Popular Tests",
		defaultDesc: "Master your future and avoid misfortune!",
		testCount: "{count} taken",
		promoTitle: "Not sure what to try?",
		promoBubble: "Chat with MasterS～",
		promoButton: "Start Chat",
	},
	productPanel: {
		tabsAriaLabel: "Test categories",
		categoryAll: "All",
		categoryFunTest: "Fun Tests",
		funTestTitle: "Free Fun Tests",
		testCount: "{count} taken",
		testNow: "Take Test",
		empty: "No related tests found",
		paginationAriaLabel: "Test list pagination",
		prevPage: "Previous page",
		nextPage: "Next page",
		jumpTo: "Go to",
		pageUnit: "Page",
		tabIcons: {
			all: "A",
			xinli: "P",
			bazixiangpi: "B",
			danrenyinyuan: "L",
			shiye: "C",
			liunian: "Y",
			tarot: "T",
			zonghe: "G",
			english: "En",
			other: "O",
			fun_test: "F",
		},
		categoryOther: "Other",
	},
};
